import { SvgIcon } from '@material-ui/core';
import { ReactComponent as wallet } from './voucher.svg';

export default function WalletIcon(props) {
  return <SvgIcon {...props} component={wallet} viewBox="0 0 12 12" />;
}
